import { Box, Button, createStyles, InputAdornment, makeStyles, Theme } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { useStore } from "@roc/client-portal-shared/hooks";
import { StandardDialog } from "@roc/ui";
import { PropertyAddressAutocomplete } from "@roc/ui/formComponents";
import { observer } from "mobx-react";
import { useState } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '40px',
      textAlign: 'justify',
      width: '100%',
    },
    box: {
      height: '100%',
      width: '80%',
      flexDirection: 'column',
      marginBottom: "16px"
    },
    boxButton: {
      display: 'flex',
      justifyContent: 'center'
    },
    button: {
      marginRight: '16px'
    },
    body: {
      marginBottom: '30px'
    }
  })
);



export type AddComparableSearchProps = {
  open?: boolean;
  onClose?: () => void;
  setOpenPropertyViewModal: (boolean) => void;
};


export const AddComparableSearchModal = observer((props: AddComparableSearchProps) => {
  const [addressSelected, setAddressSelected] = useState(false)
  const { compToolStoreV2: compToolStore } = useStore();
  const { searchManuallyAddedComparableFormStore } = compToolStore;
  const classes = useStyles();
  const { open, onClose, setOpenPropertyViewModal } = props;


  const handleAddressChange = addressDetails => {
    const { address_components, geometry, value } = addressDetails || {};
    searchManuallyAddedComparableFormStore.saveAddressField(
      value,
      address_components,
      geometry
    );

    if (address_components && geometry) {
      setAddressSelected(true)
    }
  };

  const handleSearch = async () => {
    compToolStore.setShowWarningMessage(false);
    const responseStatus = await compToolStore.fetchCompToolAddressData(true);

    if (responseStatus) {
      onClose();
      setOpenPropertyViewModal(true);
      setAddressSelected(false)
    } else {
      setOpenPropertyViewModal(false);
      setAddressSelected(false)
    }

  }

  const handleClose = () => {
    onClose();
  }

  const dialogContent = (
    <Box className={classes.container}>
      <Box className={classes.box}>
        <PropertyAddressAutocomplete
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" >
                <Search />
              </InputAdornment>
            ),
          }}
          enableLoanSearch={false}
          onAddressSelected={handleAddressChange} />
      </Box>
      <Box className={classes.boxButton}>
        <Button color="primary" variant="outlined" className={classes.button} onClick={handleClose}>Close</Button>
        <Button disabled={!addressSelected} color="primary" variant="contained" onClick={handleSearch} >Search</Button>
      </Box>
    </Box>
  )
  return (
    <StandardDialog
      open={open}
      title={"Add Comparable Property"}
      maxWidth="md"
      onClose={onClose}
      handleClose={onClose}
      dialogContent={dialogContent}
      removeContentBox={true}
    />
  );
})

export default AddComparableSearchModal;
